import React from 'react'
import { DataManagementGrid } from '../Common/DataManagementGrid'
import { bookColumns } from '../../Data/BookManagement/BookListData'
import { getAllData, deleteIdData } from '../../lib/booklist'
import { useDataManagement } from '../../Hooks/useDataManagement'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'

const AdminBookList = () => {
	const layout = useLayout()
	const role = useRoleBasedUrl()

	const { data: books, loading, searchQuery, setSearchQuery, handleDelete } = useDataManagement(getAllData, deleteIdData)

	const sortedBooks = React.useMemo(() => {
		return [...books].sort((a, b) => {
			const titleA = a.title ? a.title : ''
			const titleB = b.title ? b.title : ''
			return titleA.localeCompare(titleB)
		})
	}, [books])

	return (
		<DataManagementGrid
			title="Book List"
			subTitle="Manage all books in the system"
			breadcrumbTitle="Book Management"
			breadcrumbMainTitle="Book Management"
			columns={(layout, role) => bookColumns(layout, role)}
			data={sortedBooks}
			loading={loading}
			searchQuery={searchQuery}
			setSearchQuery={setSearchQuery}
			searchPlaceholder="Search by title, author, or status..."
			createButtonText="Create New Book"
			createButtonLink={`${process.env.PUBLIC_URL}/${role}/books/create/${layout}`}
			onDelete={handleDelete}
			searchFields={['title', 'author', 'isActive']}
			noDataMessage="No books found"
		/>
	)
}

export { AdminBookList }
